/* import __COLOCATED_TEMPLATE__ from './follow-up.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { FollowupOption } from 'embercom/components/operator/fin/setup/sections/follow-up/follow-up-options';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';
import { tracked } from '@glimmer/tracking';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    step: $TSFixMe;
    isReadOnly: boolean;
    editorState: EditorState;
  };
}

export default class FinFollowups extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked
  followUpInitialOption = this.args.step?.followUpType || 'follow_up';

  get step(): Fin {
    return this.args.step;
  }

  @action
  setSelectedOption(option: FollowupOption) {
    this.step.followUpType = option;
  }
  get selectedLabel() {
    let translationKey = 'operator.fin.setup.setup-and-go-live.fin-followups.followup-options.';

    switch (this.followUpInitialOption) {
      case 'follow_up':
        translationKey += 'fin-follows-up';
        break;
      case 'follow_up_with_escalation':
        translationKey += 'fin-follows-up-handoff';
        break;
      case 'no_follow_up':
        translationKey += 'no-follow-up';
        break;
    }

    return this.intl.t(translationKey);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::Sections::FollowUp': typeof FinFollowups;
    'workflows/graph-editor/node-items/steps/fin/sections/follow-up': typeof FinFollowups;
  }
}
